<template>
  <div>
    <b-modal
      id="modal-orden-trabajo"
      size="lg"
      header-bg-variant="orange"
      header-text-variant="white"
      hide-footer
      no-close-on-backdrop
    >
    <template #modal-header>
        <H4><b>Asignar Orden de Trabajo</b> </H4>
        </template>
      <!-- Tipo de Orden de Trabajo -->
      <div class="mb-4">
        <button
          v-for="tipo in orden_trabajo_tipos"
          :key="tipo.id"
          type="button"
          class="btn mr-2"
          :class="selectedTipoOrden === tipo.id ? 'btn-success' : 'btn-secondary'"
          @click="cambiarTipoOrden(tipo.id)"
        >
          {{ tipo.nombre }}
        </button>
      </div>

      <!-- Áreas disponibles -->
      <div class="mb-2" v-if="canSelectAreas"><strong>Selecciona áreas:</strong></div>
      <div class="bg-light border rounded text-center p-3" v-if="canSelectAreas">
        <button
          v-for="categoria in servicio_complementario_categoria"
          :key="categoria.id"
          type="button"
          class="btn mr-2 mb-2"
          :class="getCurrentTypeAreas().includes(categoria.id) ? 'btn-success' : 'btn-secondary'"
          @click="toggleArea(categoria.id)"
        >
          {{ categoria.nombre }}
        </button>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-end pt-3">
        <button class="btn btn-light mr-2" @click="closeOT">Cancelar</button>
        <button class="btn btn-success" @click="saveOT">Guardar</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'theModalOrdenTrabajo',
  props: {
    orden_trabajo_tipos: {
      type: Array,
      required: true,
    },

    servicio_complementario_categoria: {
      type: Array,
      required: true,
    },
    orden_trabajo_seleccionada: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedTipoOrden: null,
      selectedAreasIndividuales: [],
      selectedAreasGrupales: [],
    };
  },
  watch: {
    orden_trabajo_seleccionada: {
      handler(newVal) {
        if (newVal) {
          if (Array.isArray(newVal)) {
            // Datos vienen directamente del servidor (modo edición)
            this.procesarDatosServidor(newVal);
          } else if (typeof newVal === 'object' && newVal.selectedAreasIndividuales) {
            // Datos vienen del componente padre (modo creación)
            this.procesarDatosInternos(newVal);
          }
        } else {
          // Si no hay datos, resetear
          this.resetModal();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // Inicializar con el primer tipo si no hay datos
    if (!this.orden_trabajo_seleccionada && this.orden_trabajo_tipos.length > 0) {
      this.selectedTipoOrden = this.orden_trabajo_tipos[0].id;
    }
  },
  methods: {
    // Método para obtener áreas seleccionadas del tipo actual
    getCurrentTypeAreas() {
      return this.selectedTipoOrden === 1
        ? this.selectedAreasIndividuales
        : this.selectedAreasGrupales;
    },
    // Método para establecer áreas seleccionadas del tipo actual
    setCurrentTypeAreas(areas) {
      if (this.selectedTipoOrden === 1) {
        this.selectedAreasIndividuales = areas;
      } else {
        this.selectedAreasGrupales = areas;
      }
    },
    procesarDatosServidor(datosServidor) {
      if (!datosServidor || !Array.isArray(datosServidor)) {
        return;
      }

      // Reset areas
      this.selectedAreasIndividuales = [];
      this.selectedAreasGrupales = [];

      // Procesar datos del servidor
      datosServidor.forEach((item) => {
        if (item.estado && item.habilitado) {
          if (item.tipo_id === 1) {
            this.selectedAreasIndividuales.push(item.servicio_complementario_categoria_id);
          } else if (item.tipo_id === 2) {
            this.selectedAreasGrupales.push(item.servicio_complementario_categoria_id);
          }
        }
      });

      // Establecer tipo de orden inicial basado en los datos existentes
      // Pero permitir que el usuario cambie libremente entre tipos
      if (this.selectedAreasIndividuales.length > 0 && this.selectedAreasGrupales.length > 0) {
        // Si hay áreas de ambos tipos, establecer el tipo individual por defecto
        this.selectedTipoOrden = 1;
      } else if (this.selectedAreasIndividuales.length > 0) {
        this.selectedTipoOrden = 1;
      } else if (this.selectedAreasGrupales.length > 0) {
        this.selectedTipoOrden = 2;
      } else if (this.orden_trabajo_tipos.length > 0) {
        this.selectedTipoOrden = this.orden_trabajo_tipos[0].id;
      }
    },
    procesarDatosInternos(datosInternos) {
      if (!datosInternos) {
        return;
      }

      // Usar datos que vienen del componente padre
      this.selectedAreasIndividuales = datosInternos.selectedAreasIndividuales || [];
      this.selectedAreasGrupales = datosInternos.selectedAreasGrupales || [];

      // Establecer tipo de orden inicial basado en los datos existentes
      // Pero permitir que el usuario cambie libremente entre tipos
      if (this.selectedAreasIndividuales.length > 0 && this.selectedAreasGrupales.length > 0) {
        // Si hay áreas de ambos tipos, usar el tipo especificado o el primero
        this.selectedTipoOrden = datosInternos.tipo_orden_id || 1;
      } else if (this.selectedAreasIndividuales.length > 0) {
        this.selectedTipoOrden = 1;
      } else if (this.selectedAreasGrupales.length > 0) {
        this.selectedTipoOrden = 2;
      } else {
        // Si no hay áreas seleccionadas, usar el tipo especificado o el primero
        this.selectedTipoOrden = datosInternos.tipo_orden_id
          || this.orden_trabajo_tipos[0]?.id
          || 1;
      }
    },
    cambiarTipoOrden(tipoId) {
      // No limpiar áreas cuando se cambia de tipo, permitir que el usuario vea
      // las áreas correspondientes al tipo seleccionado
      this.selectedTipoOrden = tipoId;
    },
    openOT() {
      // Solo resetear si no hay datos seleccionados
      if (!this.orden_trabajo_seleccionada) {
        this.resetModal();
      }
      this.$bvModal.show('modal-orden-trabajo');
    },
    closeOT() {
      this.$bvModal.hide('modal-orden-trabajo');
    },
    resetModal() {
      this.selectedTipoOrden = this.orden_trabajo_tipos.length > 0
        ? this.orden_trabajo_tipos[0].id
        : null;
      this.selectedAreasIndividuales = [];
      this.selectedAreasGrupales = [];
    },
    toggleArea(areaId) {
      const areasActuales = this.getCurrentTypeAreas();
      const i = areasActuales.indexOf(areaId);
      if (i >= 0) {
        // Remover el área de la lista actual
        const newAreas = [...areasActuales];
        newAreas.splice(i, 1);
        this.setCurrentTypeAreas(newAreas);
      } else {
        // Agregar el área a la lista actual
        const newAreas = [...areasActuales, areaId];
        this.setCurrentTypeAreas(newAreas);
      }
    },
    saveOT() {
      const ordenTrabajo = [];
      const datosExistentes = this.orden_trabajo_seleccionada && this.orden_trabajo_seleccionada.orden_trabajo ? this.orden_trabajo_seleccionada.orden_trabajo : [];

      datosExistentes.forEach((item) => {
        const esIndividual = this.selectedAreasIndividuales.includes(item.servicio_complementario_categoria_id);
        const esGrupal = this.selectedAreasGrupales.includes(item.servicio_complementario_categoria_id);

        let nuevoEstado = false;
        if (item.tipo_id === 1) nuevoEstado = esIndividual;
        if (item.tipo_id === 2) nuevoEstado = esGrupal;

        ordenTrabajo.push({
          id: item.id,
          servicio_complementario_categoria_id: item.servicio_complementario_categoria_id,
          tipo_id: item.tipo_id,
          habilitado: item.habilitado ? 1 : 0,
          estado: nuevoEstado, // 👈 solo cambia el estado
        });
      });

      this.servicio_complementario_categoria.forEach((cat) => {
        const categoriaId = parseInt(cat.id, 10);

        if (
          this.selectedAreasIndividuales.includes(categoriaId) && !datosExistentes.some(
            (item) => item.servicio_complementario_categoria_id === categoriaId && item.tipo_id === 1,
          )
        ) {
          ordenTrabajo.push({
            id: 0,
            servicio_complementario_categoria_id: categoriaId,
            tipo_id: 1,
            habilitado: 1,
            estado: true,
          });
        }

        if (
          this.selectedAreasGrupales.includes(categoriaId) && !datosExistentes.some(
            (item) => item.servicio_complementario_categoria_id === categoriaId && item.tipo_id === 2,
          )
        ) {
          ordenTrabajo.push({
            id: 0,
            servicio_complementario_categoria_id: categoriaId,
            tipo_id: 2,
            habilitado: 1,
            estado: true,
          });
        }
      });

      // 3️⃣ Emitir el resultado final
      const payload = { orden_trabajo: ordenTrabajo };
      this.$emit('orden-trabajo-guardada', payload);
      this.closeOT();
    },
  },
  computed: {
    canSelectAreas() {
      // Ambos tipos de orden de trabajo permiten seleccionar áreas
      return this.selectedTipoOrden === 1 || this.selectedTipoOrden === 2;
    },
    selectedAreas() {
      // Retorna las áreas seleccionadas según el tipo actual
      return this.selectedTipoOrden === 1
        ? this.selectedAreasIndividuales
        : this.selectedAreasGrupales;
    },
  },
};
</script>
